<template>
	<div id="DWTcontainer">
		<!-- <el-button type="primary" @click="acquireImage()">扫描</el-button> -->
		<!-- <el-button type="primary" @click="UploadImage()">上传</el-button> -->
		
		<div id="dwtcontrolContainer" style="width:300px; height: 350px; margin: 0 auto;"></div>
	</div>
</template>

<script>
	import Dynamsoft from "dwt";
	import config from "@/common/env.js";
	
	// function OnHttpUploadSuccess() {
	//     console.log('successful');
	// }
	
	// function OnHttpUploadFailure(errorCode, errorString, sHttpResponse) {
	//     alert(errorString);
	// }
	
	export default {
		name: "dwt",
		props: ["is_scan", "roomId", "is_ucode", "is_fileType"],
		data() {
			return {
				DWObject: false,
				dbrObject: false,
				
			}
		},
		watch: {
			is_scan(newV) {
				console.log(newV)
				if(newV) {
					this.acquireImage()
				}
			}
		},
		created() {
			Dynamsoft.DWT.ResourcesPath = "/static/dwt-resources";
			Dynamsoft.DWT.AutoLoad = false;
			Dynamsoft.DWT.ProductKey = config.ProductKey;
			Dynamsoft.DWT.Containers = [{
				ContainerId: "dwtcontrolContainer",
				Width: "300px",
				Height: "350px"
			}, ];
			Dynamsoft.DWT.RegisterEvent("OnWebTwainReady", () => {
				this.Dynamsoft_OnReady();
			});
		},
		mounted() {
			Dynamsoft.DWT.Load();
		},
		methods: {
			Dynamsoft_OnReady() {
				this.DWObject = Dynamsoft.DWT.GetWebTwain("dwtcontrolContainer");
			},

			// Acquire Image
			acquireImage() {
				let _this = this;
				this.DWObject.SelectSourceAsync()
					.then(
						() => {
							return this.DWObject.AcquireImageAsync({
								// ImageLength: 7020,
								// ImageWidth: 5100,
								// Unit: Dynamsoft.DWT.EnumDWT_UnitType.TWUN_PIXELS,
								PixelType: Dynamsoft.DWT.EnumDWT_PixelType['TWPT_RGB'],
								Resolution: 300,
								IfDisableSourceAfterAcquire: true
							}).then(() => {
								_this.UploadImage()
							})
						}
					)
					.catch(
						(exp) => {
							alert(exp.message)
							_this.$emit("changeScanState", {state: false})
						}
					)
			},
			
			
			//
			UploadImage() {
				let _this = this;
			    if (this.DWObject) {
			        if (this.DWObject.HowManyImagesInBuffer == 0)
			            return;
			
			        var strHTTPServer = location.hostname;
			        var strUlr = "http://";
			        var _strPort = location.port == "" ? 80 : location.port;
			        if (Dynamsoft.Lib.detect.ssl == true) {
			            _strPort = location.port == "" ? 443 : location.port;
			            strUlr = "https://";
			        }
			
			        strUlr = strUlr + strHTTPServer + ":" + _strPort;
			        var CurrentPathName = unescape(location.pathname);
			        var CurrentPath = CurrentPathName.substring(0, CurrentPathName.lastIndexOf("/") + 1);
			        // var strActionPage = strUlr + CurrentPath + "SaveToFile.aspx";
					var strActionPage = strUlr;
					
					var strPageType = "jpg";
					var strImageType = 1;
					// switch (strPageType) {
					// 	case "bmp": strImageType = 0; break;
					// 	case "jpg": strImageType = 1; break;
					// 	case "tif": strImageType = 2; break;
					// 	case "png": strImageType = 3; break;
					// 	case "pdf": strImageType = 4; break;
					// }
					
					var fileName = new Date().getTime();
					var uploadfilename = fileName + "." + strPageType;
					
			        // this.DWObject.ClearAllHTTPFormField();
			        // this.DWObject.SetHTTPFormField('extraInfo', '123');
					// this.DWObject.SetHTTPHeader('TR-TOKEN', '123');
					
					var aryIndex = [];
					var allPages = {checked: true};
					if (allPages.checked == true) {
			            for (var i = 0; i < this.DWObject.HowManyImagesInBuffer; i++)
							// aryIndex.push(i);
							aryIndex = [i];
			
						if (strPageType == "tif") {
			                this.DWObject.HTTPUpload(
								strActionPage, aryIndex, Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF,
			                    Dynamsoft.DWT.EnumDWT_UploadDataFormat.Binary, uploadfilename, _this.OnHttpUploadSuccess, _this.OnHttpUploadFailure
							);
						}
						else if (strPageType == "pdf") {
							this.DWObject.HTTPUpload(
								strActionPage, aryIndex, Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF,
								Dynamsoft.DWT.EnumDWT_UploadDataFormat.Binary, uploadfilename, _this.OnHttpUploadSuccess, _this.OnHttpUploadFailure
							);
						}
						else if (strPageType == "jpg") {
							console.log(aryIndex)
							this.DWObject.ChangeImageSize(aryIndex, 5100, 7020, Dynamsoft.DWT.EnumDWT_InterpolationMethod.IM_BICUBIC, function() {

								// _this.DWObject.RotateLeft(aryIndex, function() { //向左旋转

									_this.DWObject.ConvertToBlob(aryIndex, Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG,  function(result, _indices, type) {
										console.log(result)
										let params = new FormData();
										params.append("file", result, uploadfilename);
										params.append("fileType", _this.is_fileType);
										params.append("uCode", _this.is_ucode);
										params.append("recordId", _this.roomId);
										
										// _this.$axios.post(`/admin/appointment/upload/file`, params).then(res => {
										_this.$axios.post(`/admin/appointment/upload/penalties`, params).then(res => {
											console.log(res)
											if(res.data.code == 0) {
												_this.$emit("changeScanState", {state: true, url: res.data.data.url})
											} else {
												_this.$message.error(res.data.msg)
												_this.$emit("changeScanState", {state: false})
											}
										})
									}, function(errorCode, errorString) {
										console.log(errorCode)
										console.log(errorString)
										_this.$message.error(errorString)
										_this.$emit("changeScanState", {state: false})
									})

								// }, function(errorCode, errorString) {
								// 	console.log(errorCode)
								// 	console.log(errorString)
								// })

							}, function(errorCode, errorString) {
								console.log(errorCode)
								console.log(errorString)
								_this.$emit("changeScanState", {state: false})
							})

							// this.DWObject.ConvertToBlob(aryIndex, Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG,  function(result, _indices, type) {
							// 	console.log(result)
							// 	let params = new FormData();
							// 	params.append("file", result, uploadfilename)
							// 	params.append("fileType", 7)
								
							// 	_this.$axios.post(`/admin/appointment/upload/file`, params).then(res => {
							// 		console.log(res)
							// 		if(res.data.code == 0) {
							// 			_this.$emit("changeScanState", {state: true, url: res.data.data.url})
							// 		} else {
							// 			_this.$message.error(res.data.msg)
							// 			_this.$emit("changeScanState", {state: false})
							// 		}
							// 	})
							// }, function(errorCode, errorString) {
							// 	console.log(errorCode)
							// 	console.log(errorString)
							// 	_this.$message.error(errorString)
							// 	_this.$emit("changeScanState", {state: false})
							// })
						}
					} else {
						if (strPageType == "jpg") {
							if (this.DWObject.GetImageBitDepth(this.DWObject.CurrentImageIndexInBuffer) == 1)
								this.DWObject.ConvertToGrayScale(this.DWObject.CurrentImageIndexInBuffer);
						}
			            aryIndex.push(this.DWObject.CurrentImageIndexInBuffer);
						
						this.DWObject.HTTPUpload(
							strActionPage, aryIndex, strImageType,
							Dynamsoft.DWT.EnumDWT_UploadDataFormat.Binary, uploadfilename, _this.OnHttpUploadSuccess, _this.OnHttpUploadFailure
						);
					}
			    }
			},
			
			OnHttpUploadSuccess() {
				console.log('successful');
			},
			
			OnHttpUploadFailure(errorCode, errorString, sHttpResponse) {
				alert(errorString);
				this.$emit("changeScanState", {state: false})
			},

			
		}
	}
</script>

<style>
	#dwtcontrolContainer>div {
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// dwt.vue?4846dbd8